import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import authService from 'auth/AuthService';

export const PrivateRoute = ({
   component: Component,
   ...rest
   }) => (
     <Route
       {...rest}
       component={
            (props) => (
                (authService.isTokenValid())
                    ? <Component {...props} />
                    : (<Redirect to="/apiv1/sign-in" />)
            )
        }
     />
);

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
};
